/**
 * The Lead CRM brand mark: a three-bar funnel (the recruiting pipeline),
 * drawn in currentColor so it inherits its context (white in the app bar,
 * cyan elsewhere). A deliberate custom mark — not a stock icon — so the
 * product reads as branded rather than generic.
 */
export default function CrmMark({ className = 'h-5 w-5' }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true" focusable="false">
      <rect x="3" y="4.4" width="18" height="3.6" rx="1.8" fill="currentColor" />
      <rect x="6.5" y="10.2" width="11" height="3.6" rx="1.8" fill="currentColor" opacity="0.78" />
      <rect x="10" y="16" width="4" height="3.6" rx="1.8" fill="currentColor" opacity="0.56" />
    </svg>
  );
}
